import React from 'react'
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom'
import PublicPortalRoute from '../modules/portal/PublicPortalRoute'
import ProtectedPortalRoute from '../modules/portal/ProtectedPortalRoute'
import MainMenuPage from './pages/MainMenuPage'
import GeneralInfoPage from './pages/GeneralInfoPage'
import LinkPage from './pages/LinkPage'
import PromotionPage from './pages/PromotionPage'
import ImagePage from './pages/ImagePage'
import NotFoundPage from './pages/NotFoundPage'
import SigninPage from './pages/SigninPage'
import errorSigninToast from './templates/toast/errorSigninToast';


export default () => (
  <Router>
    <Switch>
      <PublicPortalRoute path="/:portalId/signin" component={SigninPage} />
      <ProtectedPortalRouteWithError
        path="/:portalId/promotion"
        component={PromotionPage}
      />
      <ProtectedPortalRouteWithError path="/:portalId/link" component={LinkPage} />
      <ProtectedPortalRouteWithError path="/:portalId/image" component={ImagePage} />
      <ProtectedPortalRouteWithError
        path="/:portalId/info"
        component={GeneralInfoPage}
      />
      <ProtectedPortalRouteWithError path="/:portalId/menu" component={MainMenuPage} />
      <ProtectedPortalRouteWithError path="/:portalId" component={MainMenuPage} />
      <Route path="/" component={NotFoundPage} />
    </Switch>
  </Router>
)

const ProtectedPortalRouteWithError = props => (
  <ProtectedPortalRoute {...props} onFetchPortalError={errorSigninToast}/>
)




// WEBPACK FOOTER //
// ./src/components/AppRouter.js